import React, { useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import { getImages } from '../../Componments/Frontend/const';
import ContactForm from '../../Componments/Frontend/Common/ContactForm';
import HomeAbout from '../../Componments/Frontend/Home/HomeAbout';
import HomeVideo from '../../Componments/Frontend/Home/HomeVideo';
import HomeServices from '../../Componments/Frontend/Home/HomeServices';
import FeaturedVehicles from '../../Componments/Frontend/Home/FeaturedVehicles';
import ServiceCenter from '../../Componments/Frontend/Home/ServiceCenter';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AboutScroll from '../../Componments/Frontend/Home/AboutScroll';

gsap.registerPlugin(ScrollTrigger);
const Home = () => {
    var slSettings = {
        speed: 2000,
        infinite: true,
        slidesToShow: 8,
        centerMode: false,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        dots: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 8,
                    speed: 12000,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1080,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }]
    };
    return (
        <>
                <HomeVideo/>
                <HomeServices/>
                <FeaturedVehicles/>
                <ServiceCenter/>
                <section className='logos-wrap'>
                    <div class="logos-slider">
                        <div class="logos-slide-track">
                            <div className='logos-slide'>
                                <img src={getImages('logo-benz.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('porsche-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('maserati-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('ferrari-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('bmw-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('audi.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-lambo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('landrover-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-benz.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('porsche-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('maserati-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('ferrari-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('bmw-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('audi.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-lambo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('landrover-logo.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                </section>
                <section className='about-wrap'>
                    <HomeAbout />
                </section>
                <section className='getin-touch-wrap'>
                    <div className='container'>
                        <div className='main-title tex-center'>
                            <span className='position-relative add-before-border add-after-border'>Get in Touch</span>
                        </div>
                        <div className='mt-5 row mlr-40'>
                            <div className='col-md-6 pt-2 wow fadeInLeft' data-wow-duration="1s" data-wow-delay="0.5s">
                                <iframe src="https://snazzymaps.com/embed/654124" width="100%" height="465" style={{ border: 'none' }}></iframe>

                                <div className='gt-info mt-5'>
                                    <div className='gt-address'>3201 S. Federal Hwy Delray Beach, FL 33483</div>
                                    <div className='gt-phone mt-2'><a href='tel:5612660009' className='text-white'>(561) 266-0009</a></div>
                                </div>
                            </div>
                            <div className='col-md-6 wow fadeInRight' data-wow-duration="1s" data-wow-delay="1s">
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </section>
        </>
    )
}

export default Home